<template>
  <v-menu top offset-y :left="!$vuetify.rtl" contentClass="multi-menu">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="multi-menu__activator" data-testid="selector-btn" icon v-bind="attrs" v-on="on">
        <v-icon size="16" data-testid="btn-icon">
          {{activatorIcon}}
        </v-icon>
        <span v-if="activatorText" class="multi-menu__activator-text" data-testid="btn-text">
          {{activatorText}}
        </span>
      </v-btn>
    </template>

    <v-list v-for="level in levels">
      <v-tooltip content-class="multi-menu__tooltip" nudge-top="-20" top v-for="item in itemsPerLevel(level)">
        <template v-slot:activator="{ on, attrs }">
          <div v-on="item.tooltip && on">
            <VcitaMultiLevelMenuItem v-bind="attrs"
                                     :text="item.text"
                                     :disabled="item.disabled"
                                     :active="item.active"
                                     :icon="item.icon"
                                     :link="item.link"
                                     :value="item.value"
                                     @click="$emit('click', item)"/>
          </div>
        </template>
        <span>{{item.tooltip}}</span>
      </v-tooltip>
      <hr class="menu-separator"/>
    </v-list>
  </v-menu>
</template>

<script>
import VcitaMultiLevelMenuItem from "./VcitaMultiLevelMenuItem";
export default {
  name: 'VcitaMultiLevelMenu',
  components: {VcitaMultiLevelMenuItem},
  props: {
    items: {
      type: Array,
      required: true
    },
    activatorIcon: {
      type: String,
      required: true
    },
    activatorText: {
      type: String,
      required: false,
    },
  },
  computed: {
    levels() {
      const levels = this.items.map(item => item.level)
      const sortedLevels = [...new Set(levels)].sort((a,b) => a-b)
      return sortedLevels
    },
  },
  methods: {
    itemsPerLevel(level) {
      return this.items
        .filter(item => item.level === level)
        .sort((a,b) => a.position - b.position)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.multi-menu {
  background-color: $white-color-1;

  &__activator {
    background-color: $grey-color-18;
  }

  &__tooltip {
    font-size: 12px;
  }
}

.v-list{
  padding: 0;

  &:last-child hr {
    display: none;
  }

  .menu-separator {
    margin: 4px 0;
    border: 0;
    height: 1px;
    background-color: $grey-color-7;
  }
}
</style>
